<template>
  <header class="sa-list-header">
    <div class="sa-list-header__lead">
      <h1 class="sa-list-header__title">{{ title }}</h1>
      <p v-if="subtitle" class="sa-list-header__subtitle">{{ subtitle }}</p>
    </div>
    <div v-if="$slots.actions" class="sa-list-header__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'ListPageHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  },
};
</script>

<style scoped>
.sa-list-header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem 1.5rem;
  padding: 1.5rem 1.75rem 1.25rem;
  background: linear-gradient(180deg, #fafbff 0%, #ffffff 100%);
  border-bottom: 1px solid var(--dashboard-border, #e8eaf0);
}

.sa-list-header__title {
  margin: 0 0 0.35rem;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--dashboard-text, #191c24);
  text-align: left;
}

.sa-list-header__subtitle {
  margin: 0;
  font-size: 0.9375rem;
  line-height: 1.45;
  color: var(--dashboard-muted, #697386);
  text-align: left;
}

.sa-list-header__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

@media (max-width: 768px) {
  .sa-list-header {
    padding: 1.25rem;
  }

  .sa-list-header__title {
    font-size: 1.5rem;
  }

  .sa-list-header__actions {
    width: 100%;
  }
}
</style>
